var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fb4455",
    d: "M107.355 322.931H53.118c-13.682 0-28.344-7.493-28.344-33.899 0-13.682 11.092-24.774 24.774-24.774h57.806z",
    "data-original": "#fb4455",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f7a",
    d: "M470.71 0H132.129a8.258 8.258 0 0 0-8.258 8.258v462.256h355.097V8.258z",
    "data-original": "#ff5f7a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb4455",
    d: "M478.968 0h-8.258v412.903c0 27.365-22.183 49.548-49.548 49.548v16.516h57.806a8.258 8.258 0 0 0 8.258-8.258V8.258A8.258 8.258 0 0 0 478.968 0z",
    "data-original": "#fb4455",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceaec",
    d: "M363.355 33.032H99.097a8.258 8.258 0 0 0-8.258 8.258v405.441l7.89 15.747-7.89 16.49v24.774A8.258 8.258 0 0 0 99.097 512h8.258l16.459-7.49h322.859V122.454z",
    "data-original": "#eceaec",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbd8db",
    d: "M371.613 478.968H90.839V330.323h280.774c9.122 0 16.516 7.395 16.516 16.516v115.613c0 9.121-7.395 16.516-16.516 16.516z",
    "data-original": "#dbd8db",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f7a",
    d: "M355.097 313.806H49.548c-13.682 0-24.774-11.092-24.774-24.774v148.645c0 13.682 11.092 24.774 24.774 24.774l17.904-8.326h296.47v-130.76z",
    "data-original": "#ff5f7a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbd8db",
    d: "M449.356 110.775 376.451 37.87a16.518 16.518 0 0 0-11.679-4.837h-1.417v74.323c0 9.122 7.395 16.516 16.516 16.516h49.548a8.258 8.258 0 0 1 8.258 8.258v313.806c0 27.365-22.184 49.548-49.548 49.548H123.871c-9.122 0-16.516 7.395-16.516 16.516h338.581a8.258 8.258 0 0 0 8.258-8.258V122.454c0-4.381-1.741-8.582-4.838-11.679z",
    "data-original": "#dbd8db",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb4455",
    d: "M355.097 313.806v99.097c0 18.243-14.789 33.032-33.032 33.032h-256c-9.122 0-16.516 7.395-16.516 16.516h305.548c9.122 0 16.516-7.395 16.516-16.516V330.323c0-9.122-7.395-16.517-16.516-16.517z",
    "data-original": "#fb4455",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.242 412.903h-.089c-4.565 0-8.21 3.698-8.21 8.258s3.734 8.258 8.298 8.258 8.258-3.698 8.258-8.258-3.693-8.258-8.257-8.258zM137.823 346.69h-18.435a8.256 8.256 0 0 0-8.258 8.258v66.214a8.256 8.256 0 0 0 8.258 8.258 8.256 8.256 0 0 0 8.258-8.258v-20.547c3.718-.02 7.81-.038 10.177-.038 15.065 0 27.315-12.089 27.315-26.944-.001-14.855-12.251-26.943-27.315-26.943zm0 37.37c-1.707 0-6.346.009-10.177.021v-20.876h10.177c5.855 0 10.798 4.774 10.798 10.427s-4.944 10.428-10.798 10.428zM206.016 346.746h-18.742a8.26 8.26 0 0 0-5.847 2.423 8.246 8.246 0 0 0-2.411 5.851l.137 66.173a8.256 8.256 0 0 0 2.444 5.831 8.255 8.255 0 0 0 5.815 2.395h.032s13.887-.052 19.266-.145c19.863-.351 34.282-17.673 34.282-41.194 0-24.721-14.057-41.334-34.976-41.334zm.403 66.012c-2.5.044-6.863.081-10.782.105-.024-7.819-.089-49.601-.089-49.601h10.468c13.613 0 18.46 12.819 18.46 24.819 0 12.125-5.581 24.459-18.057 24.677zM289.782 379.266h-16.516v-16.06h18.653c4.565 0 8.258-3.698 8.258-8.258s-3.694-8.258-8.258-8.258h-26.911a8.256 8.256 0 0 0-8.258 8.258v66.415c0 4.56 3.694 8.258 8.258 8.258s8.258-3.698 8.258-8.258v-25.581h16.516c4.565 0 8.258-3.698 8.258-8.258s-3.693-8.258-8.258-8.258z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#dbd8db",
    d: "M320.129 272.032h-96.194a8.016 8.016 0 0 1-8.016-8.016V143.774a8.016 8.016 0 0 1 8.016-8.016h68.825c2.126 0 4.165.845 5.668 2.348l27.369 27.369a8.016 8.016 0 0 1 2.348 5.668v92.873a8.016 8.016 0 0 1-8.016 8.016z",
    "data-original": "#dbd8db",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b8b2b8",
    d: "M328.145 171.143a8.016 8.016 0 0 0-2.348-5.668l-27.369-27.369a8.016 8.016 0 0 0-5.668-2.348h-4.696v32.065a8.016 8.016 0 0 0 8.016 8.016h32.065z",
    "data-original": "#b8b2b8",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.18b95b79aa250371b1c6c6f64a37e225.svg";
export { ForwardRef as ReactComponent };